import React from "react"
import { Switch } from "react-router-dom"
import {APP_BROWSER_ROUTES, APP_ROUTES} from "../constants/AppGlobal";

// Async Component
import asyncComponent from "../components/asyncComponent/AsyncComponent";

// Route Type
import DefaultRoute from "./types/DefaultRoute";

// Layouts
import DefaultLayout from "../layouts/DefaultLayout";

// Pages
const AsyncHomePage = asyncComponent( () => import("../pages/home/HomePage"));
const AsyncPlansPage = asyncComponent( () => import("../pages/plans/PlansPage"));
const AsyncCheckoutPage = asyncComponent( () => import("../pages/checkout/CheckoutPage"));
const AsyncSegmentationPage = asyncComponent( () => import("../pages/segmentation/SegmentationPage"));
const AsyncRCELandingPage = asyncComponent( () => import("../pages/RCELandingPage"));
const AsyncInvitePage = asyncComponent( () => import("../pages/InvitePage"));

export default ({childProps}) => {

    return(
        <Switch>

            <DefaultRoute
                path={APP_ROUTES.PLANS_SIGN_UP}
                exact
                component={AsyncPlansPage}
                props={childProps}
                layoutProps={{
                    pageName: "Pricing Page",
                    hasHeader: false
                }}
                layout={DefaultLayout}
            />

            <DefaultRoute
                path={APP_ROUTES.PLANS_PAGE}
                exact
                component={AsyncPlansPage}
                props={childProps}
                layoutProps={{
                    pageName: "Plans Page",
                    hasHeader: false
                }}
                layout={DefaultLayout}
            />

            <DefaultRoute
                path="/new-pricing.html"
                exact
                component={AsyncPlansPage}
                props={childProps}
                layoutProps={{
                    pageName: "New Pricing Page",
                    hasHeader: false
                }}
                layout={DefaultLayout}
            />

            <DefaultRoute
                path="/api/4/pages/new-edu-page.html"
                exact
                component={AsyncPlansPage}
                props={childProps}
                layoutProps={{
                    pageName: "New Pricing Page",
                    hasHeader: false
                }}
                layout={DefaultLayout}
            />

            <DefaultRoute
                path={APP_ROUTES.HOMEPAGE}
                exact
                component={AsyncHomePage}
                layout={DefaultLayout}
                props={childProps}
                layoutProps={{
                    pageName: "Home Page"
                }}
            />

            <DefaultRoute
                path={APP_BROWSER_ROUTES.SEGMENTATION_PAGE_STEP1}
                exact
                component={AsyncSegmentationPage}
                layout={DefaultLayout}
                props={{...childProps, segmentationStep: 1}}
                layoutProps={{
                    pageName: "Segmentation Page",
                    hasHeader: false
                }}
            />

            <DefaultRoute
                path={APP_BROWSER_ROUTES.SEGMENTATION_PAGE_STEP2}
                exact
                component={AsyncSegmentationPage}
                layout={DefaultLayout}
                props={{...childProps, segmentationStep: 2}}
                layoutProps={{
                    pageName: "Segmentation Page",
                    hasHeader: false
                }}
            />

            <DefaultRoute
                path={APP_BROWSER_ROUTES.SEGMENTATION_PAGE_STEP3}
                exact
                component={AsyncSegmentationPage}
                layout={DefaultLayout}
                props={{...childProps, segmentationStep: 3}}
                layoutProps={{
                    pageName: "Segmentation Page",
                    hasHeader: false
                }}
            />

            <DefaultRoute
                path={APP_BROWSER_ROUTES.SEGMENTATION_PAGE_STEP4}
                exact
                component={AsyncSegmentationPage}
                layout={DefaultLayout}
                props={{...childProps, segmentationStep: 4}}
                layoutProps={{
                    pageName: "Segmentation Page",
                    hasHeader: false
                }}
            />

            <DefaultRoute
                path={APP_BROWSER_ROUTES.SEGMENTATION_PAGE_STEP5}
                exact
                component={AsyncSegmentationPage}
                layout={DefaultLayout}
                props={{...childProps, segmentationStep: 5}}
                layoutProps={{
                    pageName: "Segmentation Page",
                    hasHeader: false
                }}
            />

            <DefaultRoute
                path={APP_BROWSER_ROUTES.INVALID_EMAIL_PAGE}
                exact
                component={AsyncSegmentationPage}
                layout={DefaultLayout}
                props={{...childProps, segmentationStep: 'invalid-email'}}
                layoutProps={{
                    pageName: "Invalid Email Page",
                    hasHeader: false
                }}
            />

            <DefaultRoute
                path={APP_BROWSER_ROUTES.PLANS_PAGE_BROWSER}
                exact
                component={AsyncPlansPage}
                props={childProps}
                layoutProps={{
                    pageName: "Plans Page",
                    hasHeader: false
                }}
                layout={DefaultLayout}
            />

            <DefaultRoute
                path={APP_BROWSER_ROUTES.CHECKOUT_SUMMARY_PAGE}
                exact
                component={AsyncCheckoutPage}
                layout={DefaultLayout}
                props={{...childProps}}
                layoutProps={{
                    pageName: "Checkout Page",
                    hasHeader: false
                }}
            />

            <DefaultRoute
                path={APP_BROWSER_ROUTES.RCE_LANDING}
                exact
                component={AsyncRCELandingPage}
                layout={DefaultLayout}
                props={{...childProps}}
                layoutProps={{
                    pageName: "RCE Login",
                    hasHeader: false
                }}
            />

            <DefaultRoute
                path={APP_ROUTES.INVITE_PAGE}
                exact
                component={AsyncInvitePage}
                layout={DefaultLayout}
                props={{...childProps}}
                layoutProps={{
                    pageName: "Invitation page",
                    hasHeader: false
                }}
            />

            <DefaultRoute
                path={APP_ROUTES.INVITE_PAGE_SLASH}
                exact
                component={AsyncInvitePage}
                layout={DefaultLayout}
                props={{...childProps}}
                layoutProps={{
                    pageName: "Invitation page",
                    hasHeader: false
                }}
            />

        </Switch>
    );
}